import React from "react";
import { Card } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

interface TrebbleCardProps extends React.ComponentProps<typeof Card> {
  useEditorTheme?: boolean;
}

const TrebbleCard = ({ useEditorTheme, ...restProps }: TrebbleCardProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Card {...restProps} />
    </TrebbleConfigProvider>
  );
};

export default TrebbleCard; 